export default class AbstractService {
    sdk;
    basePath = 'api';
    perPage = 15;
    constructor(sdk) {
        this.sdk = sdk;
    }
    getClient() {
        return this.sdk;
    }
    async request(method, path, params, data, headers, paginate = false) {
        const response = await this.getClient()
            .request(method, path, params, data, headers);
        return this.getClient()
            .parseResponse(response, paginate);
    }
    async file(method, path, params, data, headers) {
        return this.getClient()
            .file(method, path, params, data, headers);
    }
    buildPath(path, args) {
        return this.sprintf(this.basePath + path, args);
    }
    sprintf(path, args) {
        if (typeof args === 'undefined') {
            return path;
        }
        return path.replace(/{(\w+)}/g, (match, number) => (typeof args[number] !== 'undefined' ? args[number] : match));
    }
}
